import { Dialog } from "react-native-paper";
import { Button } from "~/components/Button";
import { AlertModal, type AlertModalProps } from "~/components/feedback/AlertModal";
import { useTheme } from "~/providers/ThemeProvider";

export type ErrorModalProps = {
    retry?: () => unknown;
} & Partial<AlertModalProps>;

export const ErrorModal = ({
    retry,
    onDismiss,
    children,
    title = "Something went wrong",
    icon = "warning-outline",
    iconColour,
    ...alertModalProps
}: ErrorModalProps) => {
    const { colours } = useTheme();
    return (
        <AlertModal
            {...alertModalProps}
            icon={icon}
            iconColour={iconColour ?? colours.icon.danger}
            title={title}
            onDismiss={onDismiss}
        >
            {children}
            <Dialog.Actions>
                {retry && <Button variant="primary" title="Try again" onPress={retry} />}
                <Button variant="destructive" title="Discard" onPress={onDismiss} />
            </Dialog.Actions>
        </AlertModal>
    );
};
